/** Figma line-icon (RI-3982 "Version=Phone and online" export) — the mouse on
 * the register-online CTA. Inherits the button's text colour via currentColor. */
export const MouseIcon = () => (
  <svg
    viewBox="0 0 14.25 19"
    width="17"
    height="17"
    fill="currentColor"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(-112.375,-202.375)">
      <path d="M119.5 210.688H114.156V215.438C114.156 217.738 116.012 219.594 118.312 219.594H120.688C122.951 219.594 124.844 217.738 124.844 215.438V210.688H119.5ZM126.625 208.906V209.797V210.688V215.438C126.625 218.74 123.953 221.375 120.688 221.375H118.312C115.01 221.375 112.375 218.74 112.375 215.438V210.688V209.797V208.906V208.312C112.375 205.047 115.01 202.375 118.312 202.375H118.609H119.5H120.391H120.688C123.953 202.375 126.625 205.047 126.625 208.312V208.906ZM120.391 204.156V208.906H124.844V208.312C124.844 206.049 122.951 204.156 120.688 204.156H120.391ZM118.609 204.156H118.312C116.012 204.156 114.156 206.049 114.156 208.312V208.906H118.609V204.156Z" />
    </g>
  </svg>
);
